import { createSlice } from "@reduxjs/toolkit"

const moduleSlice = createSlice({
  name: "moduleWisePermission",
  initialState: {
    modulePermissionList: {},
  },
  reducers: {
    addModulePermissions(state, action) {
      state.modulePermissionList = action?.payload
    },
    removeModulePermission(state, action) {
      state.modulePermissionList = null
    },
  },
})

export default moduleSlice.reducer

export const { addModulePermissions, removeModulePermission } =
  moduleSlice.actions
